import React, { useContext, useState } from "react";
import { Route, Routes } from "react-router-dom";
import ScreenLoading from "../components/Loader";
import adminRouting from "../admin/routes";
import MainPage from "../main";
import recruiterRouting from "../recruiter/routes";
import artistRouting from "../artist/routes";
import waitlistRouting from "../waitlist/routes";
import PaymentPage from "../payment/pages/Payment";

/**
 * @author Sarthak Sharma.
 * @since 08-12-2023.
 * @description Application URL Mapping.
 * @returns Routes
 */

const Routing = (): React.ReactElement => {
  return (
    <>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/checkout" element={<PaymentPage />} />
        {adminRouting()}
        {/* {recruiterRouting()} */}
        {/* {artistRouting()} */}
        {waitlistRouting()}
      </Routes>
      <ScreenLoading />
    </>
  );
};

export default Routing;
